module.exports = __webpack_public_path__ + "img/drawGift2.b93989f8.png";